let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("81eQE")).then(() => parcelRequire('la4Nn'));